function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M5.55984 0.524414C2.50806 0.524414 0.0341797 2.9983 0.0341797 6.05007C0.0341797 9.10185 2.50806 11.5757 5.55984 11.5757C8.61161 11.5757 11.0855 9.10185 11.0855 6.05007C11.0855 2.9983 8.61161 0.524414 5.55984 0.524414ZM4.2072 8.34034H3.08826V4.73945H4.2072V8.34034ZM3.64082 4.2974C3.28741 4.2974 3.0589 4.04702 3.0589 3.73735C3.0589 3.42136 3.29432 3.17846 3.65521 3.17846C4.01611 3.17846 4.23713 3.42136 4.24404 3.73735C4.24404 4.04702 4.01611 4.2974 3.64082 4.2974ZM8.29389 8.34034H7.17494V6.34477C7.17494 5.88027 7.01263 5.56485 6.60799 5.56485C6.29889 5.56485 6.11528 5.77839 6.03412 5.98388C6.00419 6.05698 5.99671 6.16059 5.99671 6.26362V8.33977H4.87719V5.88776C4.87719 5.43822 4.8628 5.06236 4.84783 4.73888H5.82L5.87123 5.23907H5.89368C6.04103 5.00423 6.40193 4.65772 7.00572 4.65772C7.7419 4.65772 8.29389 5.151 8.29389 6.21124V8.34034Z",
  fill: "#EF951B"
});

function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.d426f218.svg";
export { ForwardRef as ReactComponent };